import { all } from "redux-saga/effects";
import allDiarySagas from "store/sagas/diary-sagas";
import allChapterSagas from "store/sagas/chapter-saga";
import allShareSagas from "store/sagas/share-sagas";

export default function* rootSaga() {
	yield all([allDiarySagas(), allChapterSagas(),allShareSagas()]);
}
